<template v-if="dbName && colName" class="text-center">
    <div class="row gx-1 align-items-center">
        <div class="col-auto">
            特性
        </div>
        <div class="col-4 col-lg-2">
            <d-editable-select v-model="dataId1" :options="options" max-height="150" allow-clear="true"></d-editable-select>
        </div>
    </div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto"> * </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="percentGte" @keyup.enter="queryTraits(dbName, ['weapons','armors','states','classes'], 21, dataId1, {'$lte':percentLte/100,'$gte':percentGte/100})" class="form-control">
        </div>
        <div class="col-auto"> ~ </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="percentLte" @keyup.enter="queryTraits(dbName, ['weapons','armors','states','classes'], 21, dataId1, {'$lte':percentLte/100,'$gte':percentGte/100})" class="form-control">
        </div>
        <div class="col-auto"> % </div>
        <div class="col-auto">
            <button type="submit" @click="queryTraits(dbName, ['weapons','armors','states','classes'], 21, dataId1, {'$lte':percentLte/100,'$gte':percentGte/100})" class="btn btn-primary">搜索</button>
        </div>
        <div class="col-auto align-self-end">
            <CButton color="primary" @click="visible1 = !visible1" >折叠</CButton>
        </div>
    </div>
    <CCollapse :visible="visible1">
        <json-viewer
            :value="json1"
            :expand-depth=4
            :show-double-quotes="false"
            :show-array-index="false">
        </json-viewer>
    </CCollapse>
<!-- ************* -->
    <div class="row mt-4 mp-4"></div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto">
            装备自带数值
        </div>
        <div class="col-4 col-lg-2">
            <d-editable-select v-model="dataId2" :options="options" max-height="150" allow-clear="true"></d-editable-select>
        </div>
    </div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto"> + </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="paramGte" @keyup.enter="queryEquipParams(dbName, dataId2, {'$lte':Number(paramLte),'$gte':Number(paramGte)})" class="form-control">
        </div>
        <div class="col-auto">
            ~
        </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="paramLte" @keyup.enter="queryEquipParams(dbName, dataId2, {'$lte':Number(paramLte),'$gte':Number(paramGte)})" class="form-control">
        </div>
        <div class="col-auto">
            <button type="submit" @click="queryEquipParams(dbName, dataId2, {'$lte':Number(paramLte),'$gte':Number(paramGte)})" class="btn btn-primary">搜索</button>
        </div>
        <div class="col-auto align-self-end">
            <CButton color="primary" @click="visible2 = !visible2" >折叠</CButton>
        </div>
    </div>
    <CCollapse :visible="visible2">
        <json-viewer
            :value="json2"
            :expand-depth=4
            :show-double-quotes="false"
            :show-array-index="false">
        </json-viewer>
    </CCollapse>
</template>
  
<script>
import axios from "@/utils/http"
import { CCollapse } from '@coreui/vue'
// import { CCard } from '@coreui/vue'
// import { CCardBody } from '@coreui/vue'
import { CButton } from '@coreui/vue'
import JsonViewer from 'vue-json-viewer'

export default {
    name: 'CommonQuery',
    components: {
        CCollapse, CButton,
        JsonViewer
    },
    data() {
        return {
            visible1: false,
            visible2: false,
            json1:null,
            json2:null,
            dataId1:"",
            dataId2:"",
            options:[
                {'label': '最大hp', 'value': 0},
                {'label': '最大mp', 'value': 1},
                {'label': '物理攻击', 'value': 2},
                {'label': '物理防御', 'value': 3},
                {'label': '魔法攻击', 'value': 4},
                {'label': '魔法防御', 'value': 5},
                {'label': '速度', 'value': 6},
                {'label': '幸运', 'value': 7},
            ],
            percentGte:0,
            percentLte:1000,
            paramGte:-5000,
            paramLte:5000,
        }
    },
    props: ['dbName'],
    methods: {
        queryTraits(dbName, colList, code, dataId, value){
            this.visible1 = true
            axios.post('/' + dbName + '/others', { type:'traits', colList: colList, code:code, dataId:dataId, value:value })
                .then(response => { this.json1 = response.data })
        },
        queryEquipParams(dbName, dataId, value){
            this.visible2 = true
            axios.post('/' + dbName + '/others', { type:'equipParams', dataId:dataId, value:value })
                .then(response => { this.json2 = response.data })
        }
    },
    created() {
    }
}
</script>
